module.exports = __webpack_public_path__ + "img/logo_svg.38c7ec96.svg";